goog.require('el8.template.multiuser_access.passwordHelpNoVerifiedEmail');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.passwordHelpNoVerifiedEmail = (function() {

    var that = {};

    var faxCode = null;
    var userProfileId = null;

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */
        
        if (spec.urls) { el8.service.urls.init(spec.urls); }
        
        faxCode = spec.faxCode;
        userProfileId = spec.userProfileId;
          
        
        $('.main-content').html(
            el8.template.multiuser_access.passwordHelpNoVerifiedEmail.content({
                viewDocumentUrl: el8.service.urls.get('pageViewDocument', [faxCode, userProfileId])
            })
        );
    };  

    return that;

})();